import { Col, DatePicker, Form, FormInstance, InputNumber, Radio } from 'antd'

import { Text } from 'src/components'
import { dayMonthYearFormatWithDot, disabledFutureDate } from 'src/libs'
import { useLocales } from 'src/locales'

type Props = {
  form: FormInstance
}

export const VaccineSymptomsCard = ({ form }: Props) => {
  const { t } = useLocales()

  const isYes =
    Form.useWatch(
      [
        'form',
        'symptoms',
        'vaccinePreventableInfections',
        'patientVaccinated',
        'status'
      ],
      form
    ) === 'yesAccordingToSchedule'

  const isPartiallyYes =
    Form.useWatch(
      [
        'form',
        'symptoms',
        'vaccinePreventableInfections',
        'patientVaccinated',
        'status'
      ],
      form
    ) === 'yesWithViolations'

  return (
    <>
      <Col span={24}>
        <Text>{`11. ${t('epidemiology.vaccine')}`}</Text>
      </Col>

      <Col span={24}>
        <Form.Item
          name={[
            'form',
            'symptoms',
            'vaccinePreventableInfections',
            'patientVaccinated',
            'status'
          ]}
          label="Pacientul a fost vaccinat?"
        >
          <Radio.Group>
            <Radio value="unknown">{t('epidemiology.unknown')}</Radio>
            <Radio value="no">{t('common.no')}</Radio>
            <Radio value="yesAccordingToSchedule">Da, conform schemei</Radio>
            <Radio value="yesWithViolations">
              Da, cu încălcarea schemei / incomplet
            </Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      {isYes && (
        <>
          <Col span={12}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'vaccinePreventableInfections',
                'patientVaccinated',
                'yesAccordingToSchedule',
                'numberOfDoses',
                'value'
              ]}
              label="Numărul de doze"
            >
              <InputNumber
                className="full-width"
                placeholder="Numărul de doze"
                min={1}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'vaccinePreventableInfections',
                'patientVaccinated',
                'yesAccordingToSchedule',
                'lastDoseDate',
                'value'
              ]}
              label="Data ultimei doze"
            >
              <DatePicker
                className="full-width"
                format={dayMonthYearFormatWithDot}
                disabledDate={disabledFutureDate}
                placeholder="Data ultimei doze"
              />
            </Form.Item>
          </Col>
        </>
      )}

      {isPartiallyYes && (
        <>
          <Col span={12}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'vaccinePreventableInfections',
                'patientVaccinated',
                'yesWithViolations',
                'numberOfDoses',
                'value'
              ]}
              label="Numărul de doze"
            >
              <InputNumber
                className="full-width"
                placeholder="Numărul de doze"
                min={1}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'vaccinePreventableInfections',
                'patientVaccinated',
                'yesWithViolations',
                'lastDoseDate',
                'value'
              ]}
              label="Data ultimei doze"
            >
              <DatePicker
                className="full-width"
                format={dayMonthYearFormatWithDot}
                disabledDate={disabledFutureDate}
                placeholder="Data ultimei doze"
              />
            </Form.Item>
          </Col>
        </>
      )}
    </>
  )
}
